// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environments: {
    local: {
        host: ['l', 'localhost', 'vm'],
        config: {
            secureCookies: false
        }
    },
    prod: {
        host: ['21net.com', 'nomadrail.com'],
        config: {
            secureCookies: true
        }
    }
  },
  api: {
    baseUrl: 'rest',
    endpoints: {
      config: {
        config: 'config/noc/',
        version: 'version'
      }, 
      user: {
        userList: 'user',
        createUser: 'usermanagementComposite', // TODO REST: This is not REST -> POST should be done on "user" endpoint
        resetPaswword: 'resetpassword',
        resetPasswordByEmail: 'reset',
        updateFirstLoginPassword: 'firstlogin',
        userGroupList: 'security/all/usergroup'
      },
      sim: {
        simList: 'sim',
        simTrain: 'sim/train',
        simUsage: 'sims/usage',
        simDataPeriod: 'sims/data/period',
        operators: 'operators',
        exportSim: 'export/sim-consumption'
      },
      pool: {
        poolList: 'sims/pool' // TODO REST: This is not REST -> sims/pool should be "pool"
      },
      diagtool: {
        commandResponseByUuid: 'commandresponse/uuid',
        commandList: 'commandlist',
        commandRequest: 'commandrequest',
        commandResponse: 'commandresponse',
        boxList: 'project/box'
      },
      train: {
        trainList: 'train/project',
        train: 'train',
        trainConfig: 'trainconfig'
      },
      project: {
        projectList: 'project',
      },
      referenceArea: {
        referenceAreas: 'referenceAreas',
        referenceArea: 'referenceArea',
        referenceAreasCSV: 'referenceAreasCSV',
        customReferenceAreas: 'customreferencearea'
      },
      monitoring: {
        trainsList: 'monitoring/trains',
        zabbixAlarms: 'monitoring/zabbix/alarms',
        zabbixHosts: 'monitoring/zabbix/hosts',
        trainSync: 'portal/sync/train/overview',
        zabbix: 'zabbix',
        alarm: 'alarm',
        monitoringAlarm: 'monitoring/alarm',
        trainEvents: 'trainEvents'
      },
      trip: {
        trip: '/trip'
      }, 
      incident: {
        incidentList: 'incidents'
      },
      configuration: {
        configurationList: 'configurations',
        activeConfiguration: 'config/noc/all'
      }, 
      trainSchedule: {
        timetable: 'trainschedule/timetable',
        timetableEntry: 'trainschedule/timetableentry',
        scheduleEntries: 'trainschedule/entry',
        planning: 'trainschedule/date',
        currentSchedule: 'trainschedule/current'
      },
      trainConnectivity:{
        connectivities: 'trainconnectivities',
        remarks: 'trainremarks',
        remark: 'trainremark'
      },
      advancedQuery: {
        trips: 'advanced/trips',
        recalculateTrips: 'recalculate/trips',
        recalculateTripsByTrainIds: 'recalculate/tripsByTrainIds',
        calculateTripsBySchedule: 'calculate/tripsBySchedule',
        fetchTrainSchedule: 'fetch/trainSchedule',
        waypoints: 'advanced/waypoints',
        SQIs: 'advanced/sqis'
      },
      telecomOperators: 'operators',
      export: {
        dashboardTrips: 'export/dashboard/trips'
      },
      static: {
        doc: 'static/doc'
      }
    }
  },
  mqtt: {
    initialDelayWebsocketConnectionStateChecking: 5000,
    periodicWebsocketConnectionStateChecking: 15000,
    delayCheckingWebsocketDataLastUpdate: 60000

  },
  config: {
    diagtool: {
      pollingCommandResponse: 5000,
      boxIds: [1, 2]
    },
    monitoring: {
      refreshPeriod: 10, // in seconds
    }, 
    map: {
      trainInformation: {
        defaultZoom: 12
      },
      legends: [
        {
          name: "shadowzones", 
          style: {
            'background-color': "rgb(180, 110, 246)"
          }, 
          visible: true
        },
        {
          name: "waypoints", 
          style: {
            'background-color': "#08BBCF"
          }, 
          visible: true
        },
        { 
          name: "drawings", 
          style: {
            'background-color': "#ff8a8a"
          }, 
          visible: true
        },
        {
          name: "depots",
          style: {
            'background-color': "#1fcf32"
          }, 
          visible: true
        }
      ]
    }, 
    referenceAreas: {
      types: ['WAYPOINT', 'DEPOT', 'DRAWING', 'SHADOWZONE']
    }
  },
  alarms: {
    dateFormat: 'dd/MM/yy HH:mm'
  },
  languages: {
    header: 'I18N_USERS_SETTING.LANGUAGE',
    default: 'en',
    items: [{
      code: 'fr',
      name: 'I18N_USERS_SETTING.FRENCH',
      flagIcon: 'fr'
    }, {
      code: 'en',
      name: 'I18N_USERS_SETTING.ENGLISH',
      flagIcon: 'gb'
    }, {
      code: 'it',
      name: 'I18N_USERS_SETTING.ITALIAN',
      flagIcon: 'it'
    }, {
      code: 'de',
      name: 'I18N_USERS_SETTING.GERMAN',
      flagIcon: 'de'
    }]
  },
  currencies: {
    header: 'I18N_USERS_SETTING.CURRENCY',
    default: 'EUR',
    items: [{
      currency: 'usd',
      name: 'USD',
      symbol: '$'
    }, {
      currency: 'cad',
      name: 'CAD',
      symbol: '$'
    }, {
      currency: 'gbp',
      name: 'GBP',
      symbol: '£'
    }, {
      currency: 'eur',
      name: 'EUR',
      symbol: '€'
    }, {
      currency: 'dkk',
      name: 'DKK',
      symbol: 'kr'
    }, {
      currency: 'sek',
      name: 'SEK',
      symbol: 'kr'
    }, {
      currency: 'inr',
      name: 'INR',
      symbol: '₹'
    }]
  },
  systemUnits: {
    header: 'I18N_USERS_SETTING.UNITS',
    default: 'metric',
    items: [{
      name: 'I18N_USERS_SETTING.IMPERIAL',
      metric: 'imperial',
      flagIcon: 'gb',
      symbol: 'mph'
    }, {
      name: 'I18N_USERS_SETTING.METRICS',
      metric: 'metric',
      flagIcon: 'fr',
      symbol: 'kmh'
    }]
  },
  timezones: {
    header: 'I18N_USERS_SETTING.TIMEZONE',
    default: "Etc/UTC",
    items: [
      "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
      "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
      "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
      "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
      "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
      "Etc/UTC|UTC|0|0|",
      "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
      "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
      "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5"
    ]
  },
  locales: {
    header: 'I18N_USERS_SETTING.LOCALE',
    default: 'fr_FR',
    items: [{
      'name': 'en_US',
      'label': 'I18N_USERS_SETTING.AMERICAN',
      'flag': 'us',
      'separator': ',',
      'decimalSeparator': '.'
      }, {
          'name': 'fr_FR',
          'label': 'I18N_USERS_SETTING.FRENCH',
          'flag': 'fr',
          'separator': ';',
          'decimalSeparator': ','

      }, {
          'name': 'it_IT',
          'label': 'I18N_USERS_SETTING.ITALIAN',
          'flag': 'it',
          'separator': ';',
          'decimalSeparator': ','
      }, {
          'name': 'nl_BE',
          'label': 'I18N_USERS_SETTING.BELGIAN',
          'flag': 'be',
          'separator': ';',
          'decimalSeparator': ','
      }]
  }, 
  charts : {
    defaultColors: {
      pieChart: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9','#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'], 
      operators: ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000']
    }  
  },
  trainConnectivity: {
    periods:  [
      { name: 'earlyMorning', timeSlot: '05:00 - 07:30' },
      { name: 'morning', timeSlot: '07:30 - 09:30' },
      { name: 'noon', timeSlot: '09:00 - 12:00' },
      { name: 'afternoon', timeSlot: '12:00 - 15:00' },
      { name: 'evening', timeSlot: '15:00 - 18:00' }
    ],
    periodOptions : [
      { label: '', value: 'na', color: '#000' },
      { label: 'OK', value: 'success', color: '#47a447' },
      { label: 'NOK', value: 'danger', color: 'red' },
      { label: 'COR', value: 'correctiva', color: 'darkgreen' },
      { label: 'SLOW', value: 'warn', color: '#f0ad4e' },
      { label: 'RIS', value: 'ris', color: 'CornflowerBlue' }
    ]
  }, 
  calendar: {
    "source":"https://code.google.com/archive/p/primefaces/wikis/PrimeFacesLocales.wiki",
    "locales":{
       "en":{
          "firstDayOfWeek":0,
          "dayNames":[
             "Sunday",
             "Monday",
             "Tuesday",
             "Wednesday",
             "Thursday",
             "Friday",
             "Saturday"
          ],
          "dayNamesShort":[
             "Sun",
             "Mon",
             "Tue",
             "Wed",
             "Thu",
             "Fri",
             "Sat"
          ],
          "dayNamesMin":[
             "Su",
             "Mo",
             "Tu",
             "We",
             "Th",
             "Fr",
             "Sa"
          ],
          "monthNames":[
             "January",
             "February",
             "March",
             "April",
             "May",
             "June",
             "July",
             "August",
             "September",
             "October",
             "November",
             "December"
          ],
          "monthNamesShort":[
             "Jan",
             "Feb",
             "Mar",
             "Apr",
             "May",
             "Jun",
             "Jul",
             "Aug",
             "Sep",
             "Oct",
             "Nov",
             "Dec"
          ],
          "today":"Today",
          "clear":"Clear",
          "dateFormat":"mm/dd/yy",
          "weekHeader":"Wk"
       },
       "fr":{
          "firstDayOfWeek":0,
          "closeText":"Fermer",
          "prevText":"Précédent",
          "nextText":"Suivant",
          "monthNames":[
             "Janvier",
             "Février",
             "Mars",
             "Avril",
             "Mai",
             "Juin",
             "Juillet",
             "Août",
             "Septembre",
             "Octobre",
             "Novembre",
             "Décembre"
          ],
          "monthNamesShort":[
             "Jan",
             "Fév",
             "Mar",
             "Avr",
             "Mai",
             "Jun",
             "Jul",
             "Aoû",
             "Sep",
             "Oct",
             "Nov",
             "Déc"
          ],
          "dayNames":[
             "Dimanche",
             "Lundi",
             "Mardi",
             "Mercredi",
             "Jeudi",
             "Vendredi",
             "Samedi"
          ],
          "dayNamesShort":[
             "Dim",
             "Lun",
             "Mar",
             "Mer",
             "Jeu",
             "Ven",
             "Sam"
          ],
          "dayNamesMin":[
             "D",
             "L",
             "M",
             "M",
             "J",
             "V",
             "S"
          ],
          "weekHeader":"Semaine",
          "firstDay":1,
          "isRTL":false,
          "showMonthAfterYear":false,
          "yearSuffix":"",
          "timeOnlyTitle":"Choisir l\\'heure",
          "timeText":"Heure",
          "hourText":"Heures",
          "minuteText":"Minutes",
          "secondText":"Secondes",
          "currentText":"Maintenant",
          "ampm":false,
          "month":"Mois",
          "week":"Semaine",
          "day":"Jour",
          "allDayText":"Toute la journée"
       },
       "de":{
          "firstDayOfWeek":0,
          "closeText":"Schließen",
          "prevText":"Zurück",
          "nextText":"Weiter",
          "monthNames":[
             "Januar",
             "Februar",
             "März",
             "April",
             "Mai",
             "Juni",
             "Juli",
             "August",
             "September",
             "Oktober",
             "November",
             "Dezember"
          ],
          "monthNamesShort":[
             "Jan",
             "Feb",
             "MÃ¤r",
             "Apr",
             "Mai",
             "Jun",
             "Jul",
             "Aug",
             "Sep",
             "Okt",
             "Nov",
             "Dez"
          ],
          "dayNames":[
             "Sonntag",
             "Montag",
             "Dienstag",
             "Mittwoch",
             "Donnerstag",
             "Freitag",
             "Samstag"
          ],
          "dayNamesShort":[
             "Son",
             "Mon",
             "Die",
             "Mit",
             "Don",
             "Fre",
             "Sam"
          ],
          "dayNamesMin":[
             "S",
             "M",
             "D",
             "M ",
             "D",
             "F ",
             "S"
          ],
          "weekHeader":"Woche",
          "firstDay":1,
          "isRTL":false,
          "showMonthAfterYear":false,
          "yearSuffix":"",
          "timeOnlyTitle":"Nur Zeit",
          "timeText":"Zeit",
          "hourText":"Stunde",
          "minuteText":"Minute",
          "secondText":"Sekunde",
          "currentText":"Aktuelles Datum",
          "ampm":false,
          "month":"Monat",
          "week":"Woche",
          "day":"Tag",
          "allDayText":"Ganzer Tag"
       },
       "it":{
          "firstDayOfWeek":0,
          "closeText":"Chiudi",
          "prevText":"Precedente",
          "nextText":"Prossimo",
          "monthNames":[
             "Gennaio",
             "Febbraio",
             "Marzo",
             "Aprile",
             "Maggio",
             "Giugno",
             "Luglio",
             "Agosto",
             "Settembre",
             "Ottobre",
             "Novembre",
             "Dicembre"
          ],
          "monthNamesShort":[
             "Gen",
             "Feb",
             "Mar",
             "Apr",
             "Mag",
             "Giu",
             "Lug",
             "Ago",
             "Set",
             "Ott",
             "Nov",
             "Dic"
          ],
          "dayNames":[
             "Domenica",
             "Lunedì",
             "Martedì",
             "Mercoledì",
             "Giovedì",
             "Venerdì",
             "Sabato"
          ],
          "dayNamesShort":[
             "Dom",
             "Lun",
             "Mar",
             "Mer",
             "Gio",
             "Ven",
             "Sab"
          ],
          "dayNamesMin":[
             "D",
             "L",
             "M",
             "M ",
             "G",
             "V ",
             "S"
          ],
          "weekHeader":"Sett",
          "firstDay":1,
          "isRTL":false,
          "showMonthAfterYear":false,
          "yearSuffix":"",
          "timeOnlyTitle":"Solo Tempo",
          "timeText":"Ora",
          "hourText":"Ore",
          "minuteText":"Minuto",
          "secondText":"Secondo",
          "currentText":"Data Odierna",
          "ampm":false,
          "month":"Mese",
          "week":"Settimana",
          "day":"Giorno",
          "allDayText":"Tutto il Giorno"
       }
    }
 }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.true
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
